import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  input[type=\"checkbox\"] {\n    display: none;\n    position: relative;\n    right: -999em;\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    ", ":hover & {\n      ", " {\n        background: #f9edec;\n        box-shadow: none;\n      }\n    }\n\n    :focus {\n      outline: none;\n    }\n  }\n\n  input:checked + div {\n    ", " {\n      background: #c34c3e;\n      box-shadow: none;\n      color: #ffffff;\n      ::after {\n        display: block;\n      }\n    }\n\n    &:hover {\n      ", " {\n        background: #c9c9c9;\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      width: 8px;\n      height: 8px\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    padding-bottom: 2px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    height: 36px;\n    padding-bottom: 4px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 46px;\n  font-size: 20px;\n  line-height: 100%;\n  border-radius: 23px;\n  box-shadow: inset 0px 0px 0px 2px #eaeaea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 20px 6px;\n  color: ", ";\n  ", "\n  ", "\n  ::after {\n    margin-left: 6px;\n    content: \"\";\n    display: none;\n    width: 14px;\n    height: 14px;\n    background: url(", ");\n    background-size: contain;\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  margin: 5.5px 3px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import crossImg from "../../../../images/cross-x.svg";
export var TagCheckbox = styled.div(_templateObject());
export var LabelInner = styled.span(_templateObject2(), function (props) {
  return props.theme.colors.baseFont;
}, media.xxLargeScreen(_templateObject3()), media.smallScreen(_templateObject4()), crossImg, media.xxLargeScreen(_templateObject5()));
export var Label = styled.label(_templateObject6(), TagCheckbox, LabelInner, LabelInner, LabelInner, function (props) {
  return props.theme.colors.baseFont;
});